import ApiService from "./ApiService";

const getAllColorPricingCategory = async () => {
  const url = "/GetAllColorPricingCategory";
  try {
    const result = await ApiService.get(url);

    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const getOne = async (id) => {
  const url = `/GetColorPricingCategory?Id=${id}`;
  try {
    const result = await ApiService.get(url);
    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const _params = queryString(data);
  const url = "/UpdateColorPricingCategory?" + _params;

  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "multipart/form-data",
    });
    debugger
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to update deco method",
    };
  }
};

var queryString = (params) =>
  Object.keys(params)
    .map((key) => {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    })
    .join("&");

const add = async (data) => {
  const _params = queryString(data);
  const url = "/AddColorPricingCategory?" + _params;
  debugger
  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "application/json",
    });
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to add new deco method",
    };
  }
};

const remove = async (id) => {
  const url = "/DeleteColorPricingCategory?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to remove deco method",
    };
  }
};

export default {
    getAllColorPricingCategory,
    getOne,
    update,
    add,
    remove,
};
